import type { Resource } from 'domains-work-order-authorization';
import { safeConvertToUUID } from 'uuid-encoding';

export interface EquipmentRecord {
  id?: string | null;
  channelId?: string | null;
}

export const toEquipmentResource = (record: EquipmentRecord): Resource => ({
  resourceId: safeConvertToUUID(record.id ?? ''),
  channelId: safeConvertToUUID(record.channelId ?? ''),
});
